// see types.d.ts for what these mean
export const SCRAMJETCLIENT = Symbol.for("scramjet client global");
export const SCRAMJETFRAME = Symbol.for("scramjet frame handle");
